import React from 'react'
import Flex from '../MVFlex/Flex'
import { ButtonSemantics } from './types'
import ButtonFactory, { ButtonFactoryProps } from './ButtonFactory'
import { IFlexItem } from '../MVFlex/FlexItem'

interface OmittedParams extends IFlexItem {
  semantic: string
}

export interface GroupButtonProps {
  semantic: ButtonSemantics
  buttons: Array<ButtonFactoryProps<OmittedParams>>
}

const ButtonGroup = (props: GroupButtonProps) => {
  const { buttons, semantic } = props
  const gbtn = 'mv-btn-group'
  return (
    <Flex className={gbtn} spaceSize="none">
      {buttons.map((item, index) => {
        if (item.action === 'group') {
          // no recursive component
          return null
        }
        return <ButtonFactory key={index} {...item} semantic={semantic} />
      })}
    </Flex>
  )
}

export default ButtonGroup
